import classNames from 'classnames'
import { observer } from 'mobx-react'
import { useLocation, useNavigate } from 'react-router'
import ContentState from '../../../../stores/ContentState'
import GlobalState from '../../../../stores/GlobalState'
import './index.scss'

const ClearanceCol = observer(() => {
  const navigate = useNavigate()
  const content = ContentState.clearance
  if (!content) return <></>
  const { pathname } = useLocation()
  return (
    <section className="clearance-col">
      <div className="clearance-col__block">
        <div className="clearance-col__img">
          <img src={content.bg1} />
        </div>
        <div className="clearance-col__title">{content.title1}</div>
        <div
          className="clearance-col__text"
          dangerouslySetInnerHTML={{ __html: content.list }}
        ></div>

        <div className="clearance-col__example">
          <div className="clearance-col__example-title">
            {content.example.title}
          </div>
          {content.example.list.map((li: any, i: number) => (
            <div
              className={classNames(
                'clearance-col__example-text',
                !i && 'bold',
              )}
              key={i}
              dangerouslySetInnerHTML={{ __html: li }}
            ></div>
          ))}
        </div>
      </div>
      <div className="clearance-col__block">
        <div className="clearance-col__img">
          <img src={content.bg2} />
        </div>
        <div className="clearance-col__title">{content.title2}</div>
        <div
          className="clearance-col__text parags"
          dangerouslySetInnerHTML={{ __html: content.textpart1 }}
        ></div>
        <div
          className="button black"
          onClick={() => {
            let path = pathname.includes('/for-business/')
              ? '/for-business/'
              : '/for-you/'

            let lang = GlobalState.currentLocale.lang.includes('En')
              ? '/en'
              : GlobalState.currentLocale.lang.includes('ру')
              ? '/ru'
              : ''
            navigate(`${lang}${path}accompanying-documents/`)
          }}
        >
          {content.buttonTitle}
        </div>
        <div
          className="clearance-col__text parags"
          dangerouslySetInnerHTML={{ __html: content.textpart2 }}
        ></div>
      </div>
    </section>
  )
})
export default ClearanceCol
